<!--  -->
<div class="main-alert" *ngIf="profilePlan != null && profilePlan.showAlertMessage && hasPlatform">
    <p>
        <span>{{ profilePlan.alertMessage}}</span>
        <a *ngIf="profilePlan.blockingReason == 1" class="btn btn-xs btn-info cta-button" href="/#/profile/plans">Contratar Plano</a>
        <a *ngIf="profilePlan.blockingReason == 2" class="btn btn-xs btn-info cta-button" href="/#/profile/invoices">Pagar Faturas</a>
        <a *ngIf="profilePlan.blockingReason == 3" class="btn btn-xs btn-info cta-button" href="/#/setup">Conectar API</a>
        <a *ngIf="profilePlan.blockingReason == 4 && !profilePlan.hasPendingInvoice" class="btn btn-xs btn-info cta-button" href="/#/profile/balance">ADICIONAR CRÉDITOS</a>
        <a *ngIf="profilePlan.hasPendingInvoice" target="_blank" class="btn btn-xs btn-info cta-button" href="/#/fatura/{{profilePlan.pendingInvoiceId}}">Pagar Recarga de Saldo</a>
    </p>
</div>
<div class="main-alert" style="background: #46ca46" *ngIf="profilePlan != null && profilePlan.planSeoName == 'trial' && hasPlatform">
    <p>
        <span *ngIf=" profilePlan.trialDaysLeft > 0" >
            Faltam {{ profilePlan.trialDaysLeft}} dias para acabar seu teste! Selecione o plano gratuito ou contrate o Polen com 20% de desconto 
        </span>
        <span *ngIf=" profilePlan.trialDaysLeft <= 0"> 
            Seus dias teste acabaram 😞😞 !! Selecione o plano gratuito ou contrate o Polen com 20% de desconto! 
        </span>
        <a class="btn btn-xs btn-info cta-button" href="/#/profile/plans">Selecionar Plano</a>        
    </p>
</div>
<div class="wrapper">
    <ng-progress></ng-progress>
    <div class="sidebar card" data-background-color="white" data-active-color="warning">
        <sidebar-cmp></sidebar-cmp>
    </div>
    <div class="main-panel">
        <navbar-cmp></navbar-cmp>
        <router-outlet></router-outlet>
        <!-- <div *ngIf="!isMap()"> -->
        <footer-cmp></footer-cmp>
        <!-- </div> -->
    </div>

</div>
<!-- <fixedplugin-cmp></fixedplugin-cmp> -->